import React, { useEffect, useMemo } from 'react'
import { HashRouter as Router, Redirect, useHistory } from 'react-router-dom'
import { Provider, connect } from 'react-redux'
import { Switch, Route } from 'react-router'
import { Container } from '@sencha/ext-modern'
import * as crypto from 'crypto'

import { postEvent } from '..'
import configureStore from '../store'
import Layout from '../components/Layout'
import DialogGroup from '../components/Layout/Dialog/DialogGroup'
import FileInput from '../components/Layout/FileInput'
import LinkApproval from './LinkApproval'
import ViewFile from '../components/ViewFile'

Tyan.md5 = str => {
	const md5Fn = crypto.createHash('md5')
	md5Fn.update(str || '')
	return md5Fn.digest('hex')
}
Tyan.shortMd5 = str => Tyan.md5(str).substring(0, 8)

const store = configureStore()
Tyan.dispatch = store.dispatch
/**
 * 调用格式：
 * 1、doPostEvent(eventName, {data, onEnd, ...}) 
 * 2、doPostEvent({event:eventName, data, onEnd, ...})
 * 3、doPostEvent({events:[{event:eventName, data, onSuccess?}], onEnd...})	// 调用多个请求, 其中event内的onSuccess只用于转换数据, 必须使用return 返回一个对象
 * @param {*} eventinfo 
 * @param  {*} args 
 */
Tyan.doPostEvent = (eventinfo, args = {}) => {
	eventinfo = typeof eventinfo === 'string' ? { event: eventinfo, ...args } : eventinfo
	if (eventinfo.events) {
		const { events, onEnd, onSuccess, onFailure, ...args } = eventinfo
		const promises = []

		events.forEach((event) => {
			const { event: eventName, data, onSuccess } = event
			promises.push(new Promise((resolve, reject) => {
				Tyan.doPostEvent({
					event: eventName, data, ...args,
					onEnd: ({ errorMessage, ...rest }) => errorMessage && reject(errorMessage) || resolve(onSuccess ? onSuccess(rest) : rest)
				})
			}))
		})

		Promise.all(promises)
			.then(results => Promise.resolve(results.reduce((sum, o) => ({ ...sum, ...o }), {})))
			.catch(errorMessage => Promise.resolve({ errorMessage }))
			.then(({ errorMessage, ...data }) => {
				onEnd && onEnd({ errorMessage, ...data })
				onFailure && errorMessage && onFailure({ errorMessage, ...data })
				onSuccess && !errorMessage && onSuccess(data)
			})
	} else
		postEvent(eventinfo)(store.dispatch)
}

const mapStateToProps = ({ loginInfo }) => ({
	loginInfo
})

const AppMainInner = ({ children, ...mainProps }) => {
	// Tyan.loginRedirect 
	useMemo(() => {
		Tyan.loginRedirect = () => {
			// const path = decodeURIComponent(history.location.search).substring(1)
			// setTimeout(() => history.push(path))
			return <Redirect to='/' />
		}
	}, [])

	useEffect(() => {
		return () => {
			Tyan.loginRedirect = Tyan.emptyFn
		}
	}, [])

	return <Switch>
		{children}
		<Route exact path="/LinkApproval" render={props => <LinkApproval {...props} {...mainProps} />} />
		<Route path="/ViewFile/:id" component={ViewFile} />
		{/* <Redirect exact path="/" to="/MainPage" /> */}
		<Route render={props => <Layout /* key={id}  */{...props} {...mainProps} appMainWrapped />} />
	</Switch>
}

const ReduxWrapper = connect(mapStateToProps)(({ loginInfo, ...props }) => {
	Tyan.loginInfo = loginInfo

	const { token } = loginInfo
	return <AppMainInner key={token} {...props} />
})

const RouterWrapped = props => {
	const history = useHistory()

	if (!Tyan.history) {
		// location change event
		const IGNOREPATHS = ['/', '/logout', '/mainpage']
		const handleHistoryChange = () => {
			const { pathname, search } = history.location
			const lcPathname = pathname.toLowerCase()
			// console.log('history changed:', pathname, search)
			if (IGNOREPATHS.find(o => lcPathname === o))
				return

			Tyan.locationControl.lastPathname = lcPathname

			// Tyan.locationControl.prevLocation = lcPathname === '/login' ? search.substring(1) || Tyan.locationControl.prevLocation : `${pathname}${search}`
			Tyan.locationControl.prevLocation = lcPathname === '/login' && search.substring(1) || Tyan.locationControl.prevLocation
			// console.log('new location:', Tyan.locationControl.prevLocation)
		}

		Tyan.history = history
		// lastLocation = { ...history.location }
		handleHistoryChange()

		history.listen(handleHistoryChange)

	}

	return <ReduxWrapper {...props} />
}


const AppMain = props => {
	Tyan.sysMode === 'sample' && Tyan.dispatch({
		type: 'GetLoginInfo/SUCCESS',
		receivedData: { token: "sampletoken", userName: "管理员", depName: "管理部门", lock: false, menu: [] }
	})

	useEffect(() => {
		document.getElementsByTagName('html')[0].classList.remove('x-big')
	}, [])

	return (
		<Provider store={store}>
			<Container fullscreen layout='fit'>
				<Router>
					<RouterWrapped {...props} />
				</Router>
			</Container>
			<FileInput />
			<DialogGroup />
		</Provider>
	)
}

export default AppMain